import zod from "zod";

export const schema = zod.object({
	email: zod.string().email("Formato de e-mail inválido"),
});

export type FormValues = zod.infer<typeof schema>;
